import React from 'react';
import { FlameIcon } from 'lucide-react';
import { Countdown } from './Countdown';
export function UrgencyBar() {
  return <div className="sticky top-0 z-50 w-full bg-terracotta text-cream" data-id="element-178" data-mp="3cwhesb62rtgr">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-center gap-x-3 gap-y-1 px-4 py-2.5 text-center sm:flex-row" data-id="element-179" data-mp="37vjwlyl2ezf9">
        <p className="flex items-center gap-2 text-[13px] font-bold leading-snug sm:text-sm" data-id="element-180" data-mp="32wgqsbx9gp68">
          <FlameIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-181" data-mp="2ywy9dq4new85" />
          <span data-id="element-182" data-mp="2u4etunmehr0p">
            PRECIO DE LANZAMIENTO: $11.990 en vez de $27.500.{' '}
            <span className="font-normal opacity-90" data-id="element-183" data-mp="2p529qamwyy1t">
              ¡Sumate a las más de 500 tejedoras!
            </span>
          </span>
        </p>
        <span className="flex items-center gap-2" data-id="element-184" data-mp="2k8bufpixo6hg">
          <span className="text-[11px] font-bold uppercase tracking-widest opacity-80" data-id="element-185" data-mp="2f7xj9ym1cgf7">
            Termina en
          </span>
          <Countdown variant="bar" data-id="element-186" data-mp="2b73xbas5lboy" />
        </span>
      </div>
    </div>;
}